import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ModalImage from "react-modal-image";
import { Styles } from "./styles/campusTour.js";
import axios from "axios";
import { Constant, imageDomain } from "../helper/Constants.js";

class CampusTour extends Component {
  state = {
    secTitle: "We Have Best Campus In The Region. Let's Explore The Campus.",
    all_images: [],
    loading: false,
    error: null,
  };

  componentDidMount() {
    this.getGalleryImages();
  }

  getGalleryImages = async () => {
    try {
      this.setState({ loading: true, error: null });
      const resp = await axios.get(
        Constant.getUrls.getAllGalleryImages + "?limit=100"
      );
      // adapt if resp.data.data is nested differently
      const images = resp?.data?.data ?? resp?.data ?? [];
      this.setState({ all_images: images, loading: false });
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error.message ||
        "Failed to load images";
      console.error(message);
      this.setState({ error: message, loading: false });
    }
  };

  /**
   * Decide media type for a gallery item.
   * Priority:
   *  - explicit media_type / type / mime_type fields
   *  - fallback to file extension on the URL/path
   */
  getMediaType = (item) => {
    if (!item) return "other";

    const rawType =
      (item.media_type || item.mediaType || item.type || item.mime_type || "")
        .toString()
        .toLowerCase();

    if (rawType.includes("image")) return "image";
    if (rawType.includes("video")) return "video";

    // fallback: detect by extension from URL/path/etc.
    const source =
      item.url ||
      item.image ||
      item.image_url ||
      item.file ||
      item.fileName ||
      item.filename ||
      item.path ||
      item.src ||
      "";

    if (typeof source === "string") {
      const lower = source.toLowerCase();
      if (
        lower.endsWith(".jpg") ||
        lower.endsWith(".jpeg") ||
        lower.endsWith(".png") ||
        lower.endsWith(".gif") ||
        lower.endsWith(".webp") ||
        lower.endsWith(".bmp") ||
        lower.endsWith(".svg")
      ) {
        return "image";
      }
      if (
        lower.endsWith(".mp4") ||
        lower.endsWith(".mov") ||
        lower.endsWith(".webm") ||
        lower.endsWith(".mkv") ||
        lower.endsWith(".avi")
      ) {
        return "video";
      }
    }

    return "other";
  };

  /**
   * Try several possible fields returned by APIs for an image.
   * Falls back to the original placeholder if nothing found.
   */
  getImageUrl = (item) => {
    if (!item) return process.env.PUBLIC_URL + "/assets/images/tour-1.jpg";

    // Common possible fields: url, image, image_url, filename, path
    const candidates = [
      item.url,
      item.image,
      item.image_url,
      item.file,
      item.fileName,
      item.filename,
      item.path,
      item.src,
      item.thumb, // sometimes thumbnail
    ];

    // pick first non-empty string
    const found = candidates.find(
      (c) => typeof c === "string" && c.trim().length > 0
    );
    if (found) {
      // if it's already absolute (http/https) return as-is, otherwise prefix with imageDomain if present
      if (/^https?:\/\//i.test(found)) return found;
      // if backend gives relative path starting with /, join with domain
      if (imageDomain) {
        // ensure no double slashes
        return (
          imageDomain.replace(/\/+$/, "") +
          (found.startsWith("/") ? found : "/" + found)
        );
      }
      // fallback to PUBLIC_URL prefix
      return (process.env.PUBLIC_URL || "") +
        (found.startsWith("/") ? found : "/" + found);
    }

    // final fallback to a bundled placeholder
    return process.env.PUBLIC_URL + "/assets/images/tour-1.jpg";
  };

  renderGridFromImages = () => {
    const { all_images } = this.state;

    // Only keep media that is actually an IMAGE
    const imageItems = (all_images || []).filter(
      (item) => this.getMediaType(item) === "image"
    );

    if (!imageItems || imageItems.length === 0) {
      // fallback UI with static images (preserves design while API empty or no image-type media)
      return (
        <>
          <Col lg="2" md="3">
            <div className="tour-box">
              <ModalImage
                small={process.env.PUBLIC_URL + "/assets/images/tour-1.jpg"}
                large={process.env.PUBLIC_URL + "/assets/images/tour-1.jpg"}
                alt=""
              />
            </div>
            <div className="tour-box">
              <ModalImage
                small={process.env.PUBLIC_URL + "/assets/images/tour-2.jpg"}
                large={process.env.PUBLIC_URL + "/assets/images/tour-2.jpg"}
                alt=""
              />
            </div>
          </Col>
          <Col lg="4" md="6">
            <Row>
              <Col lg="6" md="6">
                <div className="tour-box">
                  <ModalImage
                    small={process.env.PUBLIC_URL + "/assets/images/tour-3.jpg"}
                    large={process.env.PUBLIC_URL + "/assets/images/tour-3.jpg"}
                    alt=""
                  />
                </div>
              </Col>
              <Col lg="6" md="6">
                <div className="tour-box">
                  <ModalImage
                    small={process.env.PUBLIC_URL + "/assets/images/tour-4.jpg"}
                    large={process.env.PUBLIC_URL + "/assets/images/tour-4.jpg"}
                    alt=""
                  />
                </div>
              </Col>
              <Col lg="12">
                <div className="tour-box">
                  <ModalImage
                    small={process.env.PUBLIC_URL + "/assets/images/tour-wt1.jpg"}
                    large={process.env.PUBLIC_URL + "/assets/images/tour-wt1.jpg"}
                    alt=""
                  />
                </div>
              </Col>
            </Row>
          </Col>
          <Col lg="2" md="3">
            <div className="tour-box">
              <ModalImage
                small={process.env.PUBLIC_URL + "/assets/images/tour-ht.jpg"}
                large={process.env.PUBLIC_URL + "/assets/images/tour-ht.jpg"}
                alt=""
              />
            </div>
          </Col>
          <Col lg="4" md="12">
            <Row>
              <Col lg="12" md="6">
                <div className="tour-box">
                  <ModalImage
                    small={process.env.PUBLIC_URL + "/assets/images/tour-wt2.jpg"}
                    large={process.env.PUBLIC_URL + "/assets/images/tour-wt2.jpg"}
                    alt=""
                  />
                </div>
              </Col>
              <Col lg="6" md="3">
                <div className="tour-box">
                  <ModalImage
                    small={process.env.PUBLIC_URL + "/assets/images/tour-5.jpg"}
                    large={process.env.PUBLIC_URL + "/assets/images/tour-5.jpg"}
                    alt=""
                  />
                </div>
              </Col>
              <Col lg="6" md="3">
                <div className="tour-box">
                  <ModalImage
                    small={process.env.PUBLIC_URL + "/assets/images/tour-6.jpg"}
                    large={process.env.PUBLIC_URL + "/assets/images/tour-6.jpg"}
                    alt=""
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </>
      );
    }

    // Simple responsive grid of IMAGE media from the API.
    return imageItems.map((img, idx) => (
      <Col key={idx} lg="3" md="4" sm="6" xs="12" className="mb-3">
        <div className="tour-box">
          <ModalImage
            small={this.getImageUrl(img)}
            large={this.getImageUrl(img)}
            alt={img.caption || img.title || `campus-${idx}`}
            hideDownload={false}
          />
        </div>
      </Col>
    ));

    /**
     * If later you want to support videos in this component,
     * you can:
     *  - create another array with getMediaType(item) === 'video'
     *  - render them in a separate row/section with <video /> or an embedded player.
     */
  };

  render() {
    const { secTitle, loading, error } = this.state;

    return (
      <Styles>
        {/* Campus Tour */}
        <section className="campus-tour">
          <Container>
            <Row>
              <Col md="12">
                <div className="sec-title text-center">
                  <h4>{secTitle}</h4>
                </div>
              </Col>

              {loading && (
                <Col md="12" className="text-center">
                  <p>Loading images...</p>
                </Col>
              )}

              {error && (
                <Col md="12" className="text-center">
                  <p style={{ color: "red" }}>{error}</p>
                </Col>
              )}

              {/* Images grid (only media_type=image) */}
              {this.renderGridFromImages()}
            </Row>
          </Container>
        </section>
      </Styles>
    );
  }
}

export default CampusTour;
